import { createWebHistory, createRouter } from "vue-router";
/* Layout */
import Layout from "@/layout";

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: "/grainCard/supplementaryEnrollment",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "",
        component: () =>
          import(
            "@/modules/huyu-grain-card/backend/views/grainCard/supplementaryEnrollment/index.vue"
          ),
        name: "SupplementaryEnrollment",
        meta: { title: "粮库一卡通补录", icon: "edit" },
      },
    ],
  },
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index.vue"),
      },
    ],
  },
  {
    path: "/login",
    component: () => import("@/views/login"),
    hidden: true,
  },
  {
    path: "/register",
    component: () => import("@/views/register"),
    hidden: true,
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/views/error/404"),
    hidden: true,
  },
  {
    path: "/401",
    component: () => import("@/views/error/401"),
    hidden: true,
  },

  // {
  //   path: "",
  //   component: Layout,
  //   redirect: "index",
  //   children: [
  //     {
  //       path: "index",
  //       component: () => import("@/views/index"),
  //       name: "Index",
  //       meta: { title: "首页", icon: "dashboard", affix: true },
  //     },
  //   ],
  // },
  // {
  //   path: '/index',
  //   component: Layout,
  //   redirect: '/index',

  //   children: [
  //     {
  //       path: '/index',
  //       component: () => import('@/views/commonDevice/scene/index'),
  //       name: 'Index',

  //     }
  //   ]
  // },
  {
    path: "/user",
    component: Layout,
    hidden: true,
    redirect: "noredirect",
    children: [
      {
        path: "profile",
        component: () =>
          import("@/modules/huyu-core/backend/views/system/user/profile/index"),
        name: "Profile",
        meta: { title: "个人中心", icon: "user" },
      },
    ],
  },
  {
    path: "/bindDevice",
    component: Layout,
    hidden: true,
    redirect: "bindDevice",
    children: [
      {
        path: "/bindDevice",
        component: () =>
          import(
            "@/modules/huyu-smart-farm/backend/views/farming/liangShanLiangKuYunKongPingTai/placeInfo/bindDevice"
          ),
        name: "bindDevice",
        meta: { title: "绑定设备", icon: "user" },
      },
    ],
  },
  {
    path: "/channelManagement",
    component: Layout,
    hidden: true,
    redirect: "channelManagement",
    children: [
      {
        path: "channelManagement",
        component: () =>
          import(
            "@/modules/huyu-component-iot/backend/views/ioTDevices/monitor/videoConfig/channelManagement"
          ),
        name: "ChannelManagement",
        meta: { title: "视频通道管理" },
      },
    ],
  },

  {
    path: "/videoOperate",
    component: Layout,
    hidden: true,
    redirect: "VideoOperate",
    children: [
      {
        path: "videoOperate",
        component: () =>
          import(
            "@/modules/huyu-component-iot/backend/views/ioTDevices/monitor/deviceVideo/videoOperate"
          ),
        name: "VideoOperate",
        meta: { title: "设备控制" },
      },
    ],
  },

  {
    path: "/fishingPlan",
    component: Layout,
    hidden: true,
    redirect: "AddEditYSPlan",
    children: [
      {
        path: "AddEditYSPlan",
        component: () =>
          import("@/modules/huyu-fishery-trace/backend/views/fisheryTrace/fishingPlan/addEditYSPlan"),
        name: "AddEditYSPlan",
        meta: { title: "编辑渔事计划" },
      },
    ],
  },
  {
    path: "/fishingPlan",
    component: Layout,

    hidden: true,
    children: [
      {
        path: "AddEditBLPlan",
        component: () =>
          import(
            "@/modules/huyu-fishery-trace/backend/views/fisheryTrace/directSell-management/fishingPlan/addEditBLPlan"
          ),
        name: "AddEditBLPlan",
        meta: { title: "编辑捕捞计划" },
      },
    ],
  },

  {
    path: "/fishingPlan",
    component: Layout,

    hidden: true,
    children: [
      {
        path: "WeighDetail",
        component: () => import("@/modules/huyu-fishery-trace/backend/views/fisheryTrace/crabSign/weighDetail"),
        name: "WeighDetail",
        meta: { title: "称重" },
      },
    ],
  },
  {
    path: "/fishingPlan",
    component: Layout,

    hidden: true,
    children: [
      {
        path: "Pack",
        component: () => import("@/modules/huyu-fishery-trace/backend/views/fisheryTrace/mallGoods/pack"),
        name: "Pack",
        meta: { title: "装箱" },
      },
    ],
  },
  {
    path: "/salesOrderDetails",
    component: Layout,

    hidden: true,
    children: [
      {
        path: "salesOrderDetails",
        component: () =>
          import(
            "@/modules/huyu-fishery-trace/backend/views/fisheryTrace/directSell-management/salesOrder/addEdit"
          ),
        name: "SalesOrderDetails",
        meta: { title: "销售订单" },
      },
    ],
  },
  {
    path: "/writeOff",
    component: Layout,

    hidden: true,
    children: [
      {
        path: "writeOff",
        component: () => import("@/modules/huyu-fishery-trace/backend/views/fisheryTrace/storeOperate/writeOff"),
        name: "WriteOff",
        meta: { title: "核销订单" },
      },
    ],
  },
  {
    path: "/directSell-writeOff",
    component: Layout,

    hidden: true,
    children: [
      {
        path: "directSell-writeOff",
        component: () => import("@/modules/huyu-fishery-trace/backend/views/fisheryTrace/order/writeOff"),
        name: "DirectSell-writeOff",
        meta: { title: "核销订单" },
      },
    ],
  },
];

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [
  {
    path: "/system/user-auth",
    component: Layout,
    hidden: true,
    permissions: ["system:user:edit"],
    children: [
      {
        path: "role/:userId(\\d+)",
        component: () => import("@/modules/huyu-core/backend/views/system/user/authRole"),
        name: "AuthRole",
        meta: { title: "分配角色", activeMenu: "/system/user" },
      },
    ],
  },
  {
    path: "/system/role-auth",
    component: Layout,
    hidden: true,
    permissions: ["system:role:edit"],
    children: [
      {
        path: "user/:roleId(\\d+)",
        component: () => import("@/modules/huyu-core/backend/views/system/role/authUser"),
        name: "AuthUser",
        meta: { title: "分配用户", activeMenu: "/system/role" },
      },
    ],
  },
  {
    path: "/system/dict-data",
    component: Layout,
    hidden: true,
    permissions: ["system:dict:list"],
    children: [
      {
        path: "index/:dictId(\\d+)",
        component: () => import("@/modules/huyu-core/backend/views/system/dict/data"),
        name: "Data",
        meta: { title: "字典数据", activeMenu: "/system/dict" },
      },
    ],
  },
  {
    path: "/monitor/job-log",
    component: Layout,
    hidden: true,
    permissions: ["monitor:job:list"],
    children: [
      {
        path: "index/:jobId(\\d+)",
        component: () => import("@/modules/huyu-core/backend/views/monitor/job/log"),
        name: "JobLog",
        meta: { title: "调度日志", activeMenu: "/monitor/job" },
      },
    ],
  },
  {
    path: "/monitor/comprehensive",
    component: Layout,
    hidden: true,
    permissions: ["system:comprehensiveMonitor:view"],
    children: [
      {
        path: "index",
        component: () => import("@/modules/huyu-core/backend/views/monitor/comprehensive/index"),
        name: "ComprehensiveMonitor",
        meta: { title: "综合监控", activeMenu: "/monitor/comprehensive" },
      },
    ],
  },
  {
    path: "/monitor/config",
    component: Layout,
    hidden: true,
    permissions: ["system:monitorConfig:view"],
    children: [
      {
        path: "index",
        component: () => import("@/modules/huyu-core/backend/views/monitor/config/index"),
        name: "MonitorConfig",
        meta: { title: "监控配置", activeMenu: "/monitor/config" },
      },
    ],
  },
  {
    path: "/tool/gen-edit",
    component: Layout,
    hidden: true,
    permissions: ["tool:gen:edit"],
    children: [
      {
        path: "index/:tableId(\\d+)",
        component: () => import("@/modules/huyu-core/backend/views/tool/gen/editTable"),
        name: "GenEdit",
        meta: { title: "修改生成配置", activeMenu: "/tool/gen" },
      },
    ],
  },

  {
    path: "/commonDevice",
    component: Layout,
    hidden: true,
    permissions: ["iot:device:add", "iot:device:query"],
    children: [
      {
        path: "product-edit",
        component: () =>
          import("@/modules/huyu-component-iot/backend/views/ioTDevices/product/product-edit"),
        name: "ProductEdit",
        meta: { title: "编辑产品", activeMenu: "/iot/product", nocache: true },
      },
      {
        path: "device-edit",
        component: () =>
          import("@/modules/huyu-component-iot/backend/views/ioTDevices/device/device-edit"),
        name: "DeviceEdit",
        meta: {
          title: "编辑设备",
          activeMenu: "/commonDevice/device",
          noCache: true,
        },
      },
      {
        path: "gateway-things-model",
        component: () =>
          import(
            "@/modules/huyu-component-iot/backend/views/ioTDevices/varTemp/gateway-things-model"
          ),
        name: "gateway-things-model",
        meta: { title: "网关采集点配置", activeMenu: "/commonDevice/template" },
      },

      {
        path: "point",
        component: () =>
          import("@/modules/huyu-component-iot/backend/views/ioTDevices/varTemp/point"),
        name: "Point",
        meta: { title: "变量模板配置", activeMenu: "/commonDevice/varTemp" },
      },
      {
        path: "mjpoint",
        component: () =>
          import("@/modules/huyu-component-iot/backend/views/ioTDevices/varTemp/mjpoint"),
        name: "mjPoint",
        meta: { title: "变量模板配置", activeMenu: "/commonDevice/template" },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

export default router;
